/* eslint-env browser */
module.exports = window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/browser.js
// module id = 1547
// module chunks = 1